import BaseSanitizer from '@components/base/BaseSanitizer';
import ContainerWithLayout from '@components/pages/home/epnbz/Base/ContainerWithLayout';
import useI18n from '@i18n';

import Logo from './img/logo_backit.svg';

import styles from './Backit.module.scss';

const BlockBackit: React.FC = () => {
    const { t } = useI18n('Cpa');
    return (
        <section className={styles.blockBackit}>
            <ContainerWithLayout colorName="grey">
                <div className={styles.landingContainer}>
                    <div className={styles.blockBackit_wrapper}>
                        <div className={styles.blockBackit_wrapper_logo}>
                            <img src={Logo} alt="backit" />
                        </div>
                        <div className={styles.blockBackit_wrapper_text}>
                            <BaseSanitizer html={t('Own cashback service title')} tag="h3" />
                            <BaseSanitizer
                                html={t(
                                    'Over 1 million orders per month go through our cashback service.',
                                )}
                                tag="p"
                            />
                        </div>
                    </div>
                </div>
            </ContainerWithLayout>
        </section>
    );
};

export default BlockBackit;
